import type { Home3EmptyState as EmptyState } from '../../../lib/home3-feed';
import { useTranslation } from '../../../lib/i18n';
import styles from './Home3EmptyState.module.css';

/** "All" with nothing in it, inside the activity card (Figma 21853:122607). */
export function Home3EmptyState({ empty }: { empty: EmptyState }) {
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <Illustration />
      <div className={styles.copy}>
        <p className={`sym-type-small-semi-bold ${styles.title}`}>{t(empty.titleKey)}</p>
      </div>
    </div>
  );
}

/** The stacked-card picture, drawn from the frame's own geometry. Fills are tokens, so it reads in dark mode too. */
function Illustration() {
  return (
    <svg className={styles.illustration} width="120" height="43" viewBox="0 0 120 43" aria-hidden>
      <rect x="12.5" y="0" width="95" height="39" rx="6.2" fill="var(--ds-surface-dark-gray)" />
      <rect x="6.4" y="6.3" width="107.1" height="36.1" rx="6.2" fill="var(--ds-surface-default-gray)" />
      <rect x="0" y="13.2" width="120" height="29.8" rx="6.2" fill="var(--ds-surface-standard-bg)" />
      <rect x="11.6" y="22.5" width="10.8" height="10.8" rx="3.1" fill="var(--ds-fill-accent-brand-default)" />
      <path
        d="M23.5 24L17.8 29.7L15.2 27.1"
        fill="none"
        stroke="var(--ds-accent-09)"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="32.5" y="24.4" width="76.6" height="2.3" rx="1.2" fill="var(--ds-surface-default-gray)" />
      <rect x="32.5" y="29" width="48.8" height="2.3" rx="1.2" fill="var(--ds-surface-default-gray)" />
    </svg>
  );
}
